import { Link, useLocation } from 'react-router-dom';
import { handleLogout } from '../../services/api';

const Sidebar = ({ isOpen = false, toggle = () => {}, user = { name: '', profileImage: '' }, loadingUser = false }) => {
  const location = useLocation();

  // Helper function to get correct image URL (same as in Header)
  const getProfileImageUrl = (imagePath) => {
    if (!imagePath) return "https://cdn-icons-png.flaticon.com/512/149/149071.png";
    if (imagePath.startsWith('https')) {
      return imagePath;
    }
    const baseUrl = 'https://backend.adhdrapidcare.com';
    if (imagePath.startsWith('/')) {
      return `${baseUrl}${imagePath}`;
    }
    return `${baseUrl}/${imagePath}`;
  };

  const menuItems = [
    {
      label: 'Dashboard',
      path: '/psy/dashboard',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M4 4h6v6H4V4zm10 0h6v6h-6V4zM4 14h6v6H4v-6zm10 0h6v6h-6v-6z" />
        </svg>
      ),
    },
    {
      label: 'Calendar',
      path: '/psy/calendar',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z" />
        </svg>
      ),
    },
    {
      label: 'Patients',
      path: '/psy/patients',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
        </svg>
      ),
    },
    {
      label: 'Sessions',
      path: '/psy/session',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z" />
        </svg>
      ),
    },
    {
      label: 'Assessments',
      path: '/psy/assessment',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M3 5h18v2H3V5zm0 6h18v2H3v-2zm0 6h12v2H3v-2z" />
        </svg>
      ),
    },
    {
      label: 'Settings',
      path: '/psy/settings',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61
            l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41
            h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87
            C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.82,11.69,4.82,12s0.02,0.64,0.07,0.94l-2.03,1.58
            c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54
            c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96
            c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6
            s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z"/>
        </svg>
      ),
    },
  ];

  return (
    <>
      {/* Desktop Sidebar */}
      <div className="hidden lg:flex flex-col w-28 bg-gray-200 items-center fixed left-0 top-0 h-screen">
        {/* Menu Items - Scrollable */}
        <div className="flex flex-col items-center pt-20 pb-4 flex-1 overflow-y-auto scrollbar-hide">
          {menuItems.map((item, index) => {
            const isActive = location.pathname === item.path;
            return (
              <Link key={index} to={item.path} className="flex flex-col items-center mb-6">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center ${isActive ? 'bg-blue-600 text-white' : 'bg-white text-gray-500'}`}>
                  {item.icon}
                </div>
                <span className={`text-xs mt-1 ${isActive ? 'text-gray-900 font-medium' : 'text-gray-500'}`}>
                  {item.label}
                </span>
              </Link>
            );
          })}
        </div>
        {/* Logout Button - Always at bottom */}
        <div className="pb-6">
          <button 
            onClick={handleLogout}
            className="flex flex-col items-center"
          >
            <div className="w-10 h-10 rounded-full flex items-center justify-center bg-red-500 text-white hover:bg-red-600">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.59L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z" />
              </svg>
            </div>
            <span className="text-xs mt-1 text-gray-500">Logout</span>
          </button>
        </div>
      </div>

      {/* Mobile Sidebar */}
      <div className={`fixed top-0 left-0 h-full w-64 bg-gray-200 pt-20 px-4 z-50 transform transition-transform duration-300 ease-in-out lg:hidden ${isOpen ? 'translate-x-0' : '-translate-x-full'}`}>
        <button className="absolute top-4 right-4 text-xl" onClick={toggle}>✕</button>

        <div className="flex flex-col h-full justify-between">
          <div>
            {menuItems.map((item, index) => {
              const isActive = location.pathname === item.path;
              return (
                <Link
                  key={index}
                  to={item.path}
                  onClick={toggle}
                  className={`flex items-center space-x-3 py-2 px-3 rounded-lg mb-2 ${isActive ? 'bg-blue-600 text-white' : 'text-gray-700 hover:bg-gray-300'}`}
                >
                  {item.icon}
                  <span>{item.label}</span>
                </Link>
              );
            })}

            {/* Mobile Logout */}
            <button
              onClick={() => {
                handleLogout();
                toggle();
              }}
              className="flex items-center space-x-3 py-2 px-3 rounded-lg mb-2 text-red-600 hover:bg-red-50 w-full"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.59L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z" />
              </svg>
              <span>Logout</span>
            </button>
          </div>

          {/* Profile at Bottom */}
          <div className="mb-6 flex items-center space-x-3 px-3">
            {loadingUser ? (
              <>
                <div className="w-10 h-10 rounded-full bg-gray-200 animate-pulse border-2 border-white shadow"></div>
                <div>
                  <div className="h-4 bg-gray-200 rounded w-16 animate-pulse mb-1"></div>
                  <div className="h-3 bg-gray-200 rounded w-12 animate-pulse"></div>
                </div>
              </>
            ) : (
              <>
                <div className="w-10 h-10 rounded-full overflow-hidden border-2 border-white shadow">
                  <img
                    src={getProfileImageUrl(user.profileImage)}
                    alt={user.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      e.target.src = "https://cdn-icons-png.flaticon.com/512/149/149071.png";
                    }}
                  />
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-800">{user.name}</p>
                  <p className="text-xs text-gray-500">Psychiatrist</p>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
